import React from 'react';
import { Check, ShieldCheck, CreditCard, TrendingUp, Gift } from 'lucide-react';
export function PurchaseSection() {
  return <section id="purchase-section" className="py-20 bg-gradient-to-b from-white via-purple-50 to-white" data-id="element-56">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-57">
        <div className="text-center mb-16" data-id="element-58">
          <span className="inline-block bg-gradient-to-r from-purple-600 to-pink-600 text-white px-8 py-3 rounded-full text-base font-bold mb-6 shadow-xl animate-pulse" data-id="element-59">
            🔥 OFERTA ESPECIAL - TIEMPO LIMITADO
          </span>
          <h2 className="text-4xl md:text-6xl font-black text-gray-900 mb-6 leading-tight" data-id="element-60">
            Elegí tu pack y empezá hoy
          </h2>
          <p className="text-xl md:text-2xl text-gray-600 max-w-3xl mx-auto" data-id="element-61">
            Todos los packs incluyen acceso inmediato y vitalicio
          </p>
        </div>

        <div className="space-y-8 max-w-4xl mx-auto" data-id="element-62">
          {/* Pack 1: Micro y Macro Economía 360 */}
          <div className="bg-white rounded-3xl shadow-2xl border-2 border-blue-200 overflow-hidden hover:shadow-3xl transition-all duration-500" data-id="element-63">
            <div className="bg-gradient-to-br from-blue-600 to-indigo-700 text-white p-6 text-center" data-id="element-64">
              <h3 className="text-2xl md:text-3xl font-bold mb-2" data-id="element-65">
                Micro y Macro Economía 360
              </h3>
              <p className="text-blue-100 text-sm" data-id="element-66">Pack Individual</p>
            </div>

            <div className="p-6 md:p-8" data-id="element-67">
              <div className="mb-8 max-w-md mx-auto" data-id="element-68">
                <img src="https://cdn.magicpatterns.com/uploads/t4tGrHv949ortgHTghXUry/conver_micro_y_macro_(2).png" alt="Micro y Macro Economía 360" className="w-full rounded-2xl shadow-xl" data-id="element-69" />
              </div>

              <div className="text-center mb-8" data-id="element-70">
                <p className="text-sm text-gray-600 uppercase tracking-wide mb-2" data-id="element-71">
                  PRECIO ESPECIAL
                </p>
                <div className="flex items-baseline justify-center gap-3 mb-3 flex-wrap" data-id="element-72">
                  <span className="text-gray-400 line-through text-2xl md:text-3xl font-medium" data-id="element-73">
                    $39.99
                  </span>
                  <span className="text-5xl md:text-6xl font-black bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent" data-id="element-74">
                    $12.99
                  </span>
                </div>
                <p className="text-emerald-600 text-xl md:text-2xl font-bold mb-2" data-id="element-75">
                  💰 Ahorrás $27 USD
                </p>
                <p className="text-sm text-gray-500" data-id="element-76">
                  *Pagarás en la moneda de tu país
                </p>
              </div>

              <div className="space-y-4 mb-8" data-id="element-77">
                <div className="flex items-start gap-3 bg-blue-50 p-4 rounded-xl border border-blue-100" data-id="element-78">
                  <Check className="w-6 h-6 text-blue-600 flex-shrink-0 mt-0.5" data-id="element-79" />
                  <div data-id="element-80">
                    <p className="font-bold text-gray-900 text-sm md:text-base" data-id="element-81">
                      Pack Completo Micro y Macro Economía 360
                    </p>
                    <p className="text-xs md:text-sm text-gray-600" data-id="element-82">
                      Clases estructuradas para todo el año lectivo con ejemplos
                      argentinos actuales
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-3 bg-amber-50 p-4 rounded-xl border border-amber-200" data-id="element-83">
                  <Check className="w-6 h-6 text-amber-600 flex-shrink-0 mt-0.5" data-id="element-84" />
                  <div data-id="element-85">
                    <p className="font-bold text-gray-900 text-sm md:text-base" data-id="element-86">
                      4 Bonos Exclusivos (Gratis por hoy)
                    </p>
                    <p className="text-xs md:text-sm text-gray-600" data-id="element-87">
                      Banco de ejemplos, clases express, evaluaciones listas y
                      mapa anual de contenidos
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-3 bg-blue-50 p-4 rounded-xl border border-blue-100" data-id="element-88">
                  <Check className="w-6 h-6 text-blue-600 flex-shrink-0 mt-0.5" data-id="element-89" />
                  <div data-id="element-90">
                    <p className="font-bold text-gray-900 text-sm md:text-base" data-id="element-91">
                      Acceso Inmediato y Vitalicio
                    </p>
                    <p className="text-xs md:text-sm text-gray-600" data-id="element-92">
                      Descargá todo el material al instante y accedé cuando lo
                      necesitas, sin vencimiento
                    </p>
                  </div>
                </div>
              </div>

              <a href="https://checkout12.edulabs.online/cart/52910173192557:1" target="_blank" rel="noopener noreferrer" className="inline-block w-full bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 text-white font-bold py-5 px-6 rounded-2xl text-center transition-all shadow-xl hover:shadow-2xl transform hover:scale-105 text-lg" data-id="element-93">
                Acceder Ahora →
              </a>
            </div>
          </div>

          {/* Pack 2: Pack Full */}
          <div className="bg-white rounded-3xl shadow-2xl border-2 border-purple-300 overflow-hidden hover:shadow-3xl transition-all duration-500 relative" data-id="element-94">
            <div className="absolute top-6 right-6 z-10 bg-gradient-to-r from-amber-400 to-orange-500 text-white text-xs font-bold px-4 py-2 rounded-full shadow-xl animate-pulse" data-id="element-95">
              ⭐ POPULAR
            </div>
            <div className="bg-gradient-to-br from-purple-600 to-pink-600 text-white p-6 text-center" data-id="element-96">
              <h3 className="text-2xl md:text-3xl font-bold mb-2" data-id="element-97">Pack Full</h3>
              <p className="text-purple-100 text-sm" data-id="element-98">
                Micro y Macro + Emprendimientos
              </p>
            </div>

            <div className="p-6 md:p-8" data-id="element-99">
              <div className="mb-8 max-w-md mx-auto" data-id="element-100">
                <img src="https://cdn.magicpatterns.com/uploads/aurF22JWvpHZbT3h2sD5LU/ChatGPT_Image_11_ene_2026,_07_34_47_p.m..png" alt="Pack Full" className="w-full rounded-2xl shadow-xl" data-id="element-101" />
              </div>

              <div className="text-center mb-8" data-id="element-102">
                <p className="text-sm text-gray-600 uppercase tracking-wide mb-2" data-id="element-103">
                  PRECIO ESPECIAL
                </p>
                <div className="flex items-baseline justify-center gap-3 mb-3 flex-wrap" data-id="element-104">
                  <span className="text-gray-400 line-through text-2xl md:text-3xl font-medium" data-id="element-105">
                    $49.99
                  </span>
                  <span className="text-5xl md:text-6xl font-black bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent" data-id="element-106">
                    $17.99
                  </span>
                </div>
                <p className="text-emerald-600 text-xl md:text-2xl font-bold mb-2" data-id="element-107">
                  💰 Ahorrás $32 USD
                </p>
                <p className="text-sm text-gray-500" data-id="element-108">
                  *Pagarás en la moneda de tu país
                </p>
              </div>

              <div className="space-y-4 mb-8" data-id="element-109">
                <div className="flex items-start gap-3 bg-purple-50 p-4 rounded-xl border border-purple-100" data-id="element-110">
                  <Check className="w-6 h-6 text-purple-600 flex-shrink-0 mt-0.5" data-id="element-111" />
                  <div data-id="element-112">
                    <p className="font-bold text-gray-900 text-sm md:text-base" data-id="element-113">
                      Todo lo del Pack Básico
                    </p>
                    <p className="text-xs md:text-sm text-gray-600" data-id="element-114">
                      Micro y Macro Economía 360 completo + 4 bonos exclusivos
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-3 bg-gradient-to-r from-amber-50 to-orange-50 p-4 rounded-xl border-2 border-amber-300" data-id="element-115">
                  <Gift className="w-6 h-6 text-amber-600 flex-shrink-0 mt-0.5" data-id="element-116" />
                  <div data-id="element-117">
                    <p className="font-bold text-gray-900 text-sm md:text-base" data-id="element-118">
                      🎁 EXTRA: Micro-Emprendimientos Ganadores
                    </p>
                    <p className="text-xs md:text-sm text-gray-600" data-id="element-119">
                      100 ideas reales de emprendimientos para trabajar con
                      alumnos de último año
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-3 bg-purple-50 p-4 rounded-xl border border-purple-100" data-id="element-120">
                  <Check className="w-6 h-6 text-purple-600 flex-shrink-0 mt-0.5" data-id="element-121" />
                  <div data-id="element-122">
                    <p className="font-bold text-gray-900 text-sm md:text-base" data-id="element-123">
                      Acceso Inmediato y Vitalicio
                    </p>
                    <p className="text-xs md:text-sm text-gray-600" data-id="element-124">
                      Descargá todo el material al instante y accedé cuando lo
                      necesitas, sin vencimiento
                    </p>
                  </div>
                </div>
              </div>

              <a href="https://checkout12.edulabs.online/cart/52914637013357:1" target="_blank" rel="noopener noreferrer" className="inline-block w-full bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white font-bold py-5 px-6 rounded-2xl text-center transition-all shadow-xl hover:shadow-2xl transform hover:scale-105 text-lg" data-id="element-125">
                Acceder al Pack Full →
              </a>
            </div>
          </div>

          {/* Pack 3: Pack Full 360 */}
          <div className="bg-white rounded-3xl shadow-2xl border-2 border-indigo-300 overflow-hidden hover:shadow-3xl transition-all duration-500" data-id="element-126">
            <div className="bg-gradient-to-br from-indigo-600 to-blue-700 text-white p-6 text-center" data-id="element-127">
              <h3 className="text-2xl md:text-3xl font-bold mb-2" data-id="element-128">
                Pack Full 360
              </h3>
              <p className="text-indigo-100 text-sm" data-id="element-129">
                SIC + Micro/Macro + Emprendimientos
              </p>
            </div>

            <div className="p-6 md:p-8" data-id="element-130">
              <div className="mb-8 max-w-md mx-auto" data-id="element-131">
                <img src="https://cdn.magicpatterns.com/uploads/5DrJWuFpEZVEEAiXX9gqJM/Cover_SIC_360.png" alt="Pack Full 360" className="w-full rounded-2xl shadow-xl" data-id="element-132" />
              </div>

              <div className="text-center mb-8" data-id="element-133">
                <p className="text-sm text-gray-600 uppercase tracking-wide mb-2" data-id="element-134">
                  PRECIO ESPECIAL
                </p>
                <div className="flex items-baseline justify-center gap-3 mb-3 flex-wrap" data-id="element-135">
                  <span className="text-gray-400 line-through text-2xl md:text-3xl font-medium" data-id="element-136">
                    $68.99
                  </span>
                  <span className="text-5xl md:text-6xl font-black bg-gradient-to-r from-indigo-600 to-blue-600 bg-clip-text text-transparent" data-id="element-137">
                    $27.99
                  </span>
                </div>
                <p className="text-emerald-600 text-xl md:text-2xl font-bold mb-2" data-id="element-138">
                  💰 Ahorrás $40 USD
                </p>
                <p className="text-sm text-gray-500" data-id="element-139">
                  *Pagarás en la moneda de tu país
                </p>
              </div>

              <div className="space-y-4 mb-8" data-id="element-140">
                <div className="flex items-start gap-3 bg-indigo-50 p-4 rounded-xl border border-indigo-100" data-id="element-141">
                  <Check className="w-6 h-6 text-indigo-600 flex-shrink-0 mt-0.5" data-id="element-142" />
                  <div data-id="element-143">
                    <p className="font-bold text-gray-900 text-sm md:text-base" data-id="element-144">
                      Pack Micro y Macro Economía 360
                    </p>
                    <p className="text-xs md:text-sm text-gray-600" data-id="element-145">
                      Clases completas + 4 bonos exclusivos
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-3 bg-indigo-50 p-4 rounded-xl border border-indigo-100" data-id="element-146">
                  <Check className="w-6 h-6 text-indigo-600 flex-shrink-0 mt-0.5" data-id="element-147" />
                  <div data-id="element-148">
                    <p className="font-bold text-gray-900 text-sm md:text-base" data-id="element-149">
                      Pack Micro-Emprendimientos Ganadores
                    </p>
                    <p className="text-xs md:text-sm text-gray-600" data-id="element-150">
                      100 ideas de emprendimientos para último año
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-3 bg-gradient-to-r from-indigo-50 to-blue-50 p-4 rounded-xl border-2 border-indigo-300" data-id="element-151">
                  <Gift className="w-6 h-6 text-indigo-600 flex-shrink-0 mt-0.5" data-id="element-152" />
                  <div data-id="element-153">
                    <p className="font-bold text-gray-900 text-sm md:text-base" data-id="element-154">
                      🎁 EXTRA: SIC 360
                    </p>
                    <p className="text-xs md:text-sm text-gray-600" data-id="element-155">
                      Sistemas de Información Contable completo con clases
                      listas para usar
                    </p>
                  </div>
                </div>
              </div>

              <a href="https://checkout12.edulabs.online/cart/52914645565805:1" target="_blank" rel="noopener noreferrer" className="inline-block w-full bg-gradient-to-r from-indigo-600 to-blue-600 hover:from-indigo-700 hover:to-blue-700 text-white font-bold py-5 px-6 rounded-2xl text-center transition-all shadow-xl hover:shadow-2xl transform hover:scale-105 text-lg" data-id="element-156">
                Acceder al Pack Full 360 →
              </a>
            </div>
          </div>

          {/* Pack 4: Megapack */}
          <div className="bg-gradient-to-br from-purple-50 via-pink-50 to-purple-50 rounded-3xl shadow-2xl border-4 border-purple-400 overflow-hidden hover:shadow-3xl transition-all duration-500 relative" data-id="element-157">
            <div className="absolute top-6 right-6 z-10 bg-gradient-to-r from-amber-400 to-orange-500 text-white text-sm font-bold px-5 py-2 rounded-full shadow-2xl animate-pulse" data-id="element-158">
              🏆 MÁS VENDIDO
            </div>

            <div className="bg-gradient-to-r from-purple-600 to-pink-600 text-white p-4 text-center" data-id="element-159">
              <span className="text-xs md:text-sm font-bold uppercase tracking-wide" data-id="element-160">
                🔥 OFERTA ESPECIAL - MEGAPACK COMERCIAL CONTABLE
              </span>
            </div>

            <div className="p-6 md:p-8" data-id="element-161">
              <h3 className="text-2xl md:text-3xl font-black text-gray-900 mb-3 text-center" data-id="element-162">
                Llevate TODO el Megapack Comercial Contable 360
              </h3>
              <p className="text-base md:text-lg text-gray-700 mb-8 text-center" data-id="element-163">
                NTICX 360 + SIC 360 + Micro y Macro Economía 360
              </p>

              <div className="mb-8 max-w-md mx-auto" data-id="element-164">
                <img src="https://cdn.magicpatterns.com/uploads/7BHuFTuWKgnqL3pSWHpDTY/COVER_NTICX360.png" alt="Megapack Comercial Contable" className="w-full rounded-2xl shadow-2xl" data-id="element-165" />
              </div>

              <div className="bg-white rounded-2xl p-6 mb-8 shadow-lg text-center" data-id="element-166">
                <p className="text-xs md:text-sm text-gray-600 uppercase tracking-wide mb-2" data-id="element-167">
                  MEGAPACK COMERCIAL CONTABLE - PRECIO ESPECIAL
                </p>
                <div className="flex items-baseline justify-center gap-3 mb-4 flex-wrap" data-id="element-168">
                  <span className="text-gray-400 line-through text-3xl md:text-4xl font-medium" data-id="element-169">
                    $87.99
                  </span>
                  <span className="text-6xl md:text-7xl font-black bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent break-all" data-id="element-170">
                    $33.99
                  </span>
                </div>
                <p className="text-emerald-600 text-2xl md:text-3xl font-bold mb-2" data-id="element-171">
                  🎉 Ahorrás $54 USD con el megapack completo
                </p>
                <p className="text-sm text-gray-500" data-id="element-172">
                  *Pagarás en la moneda de tu país
                </p>
              </div>

              <div className="space-y-3 mb-8" data-id="element-173">
                <div className="flex items-start gap-3 bg-white p-4 rounded-xl shadow-md border border-gray-100" data-id="element-174">
                  <Check className="w-6 h-6 text-purple-600 flex-shrink-0 mt-0.5" data-id="element-175" />
                  <div data-id="element-176">
                    <p className="font-bold text-gray-900 text-sm md:text-base" data-id="element-177">
                      Pack Completo Micro y Macro Economía 360
                    </p>
                    <p className="text-xs md:text-sm text-gray-600" data-id="element-178">
                      Clases estructuradas para todo el año lectivo con ejemplos
                      argentinos actuales
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-3 bg-white p-4 rounded-xl shadow-md border border-amber-200" data-id="element-179">
                  <Check className="w-6 h-6 text-amber-600 flex-shrink-0 mt-0.5" data-id="element-180" />
                  <div data-id="element-181">
                    <p className="font-bold text-gray-900 text-sm md:text-base" data-id="element-182">
                      4 Bonos Exclusivos (Gratis por hoy)
                    </p>
                    <p className="text-xs md:text-sm text-gray-600" data-id="element-183">
                      Banco de ejemplos, clases express, evaluaciones listas y
                      mapa anual de contenidos
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-3 bg-white p-4 rounded-xl shadow-md border border-gray-100" data-id="element-184">
                  <Check className="w-6 h-6 text-purple-600 flex-shrink-0 mt-0.5" data-id="element-185" />
                  <div data-id="element-186">
                    <p className="font-bold text-gray-900 text-sm md:text-base" data-id="element-187">
                      Acceso Inmediato y Vitalicio
                    </p>
                    <p className="text-xs md:text-sm text-gray-600" data-id="element-188">
                      Descargá todo el material al instante y accedé cuando lo
                      necesitas, sin vencimiento
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-3 bg-gradient-to-r from-purple-100 to-pink-100 p-4 rounded-xl border-2 border-purple-300 shadow-md" data-id="element-189">
                  <Gift className="w-6 h-6 text-purple-600 flex-shrink-0 mt-0.5" data-id="element-190" />
                  <div data-id="element-191">
                    <p className="font-bold text-gray-900 text-sm md:text-base" data-id="element-192">
                      🎁 EXTRA: NTICX 360 + SIC 360 + MICRO Y MACRO ECONOMÍA 360
                    </p>
                    <p className="text-xs md:text-sm text-gray-600" data-id="element-193">
                      Accede al megapack comercial contable completo con clases
                      resueltas para todo el año
                    </p>
                  </div>
                </div>
              </div>

              <a href="https://checkout12.edulabs.online/cart/52914690589037:1" target="_blank" rel="noopener noreferrer" className="inline-block w-full bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white font-bold py-6 px-6 rounded-2xl text-center transition-all shadow-2xl hover:shadow-3xl transform hover:scale-105 text-lg md:text-xl uppercase break-words" data-id="element-194">
                ACCEDÉ AL MEGAPACK →
              </a>
            </div>
          </div>
        </div>

        {/* Guarantee Section */}
        <div className="mt-20 max-w-5xl mx-auto bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50 rounded-3xl p-10 md:p-14 border-2 border-indigo-200 shadow-2xl text-center" data-id="element-195">
          <div className="flex justify-center mb-8" data-id="element-196">
            <div className="bg-white p-6 rounded-full shadow-2xl" data-id="element-197">
              <ShieldCheck className="w-24 h-24 text-blue-600" data-id="element-198" />
            </div>
          </div>
          <h3 className="text-4xl md:text-5xl font-black text-gray-900 mb-6" data-id="element-199">
            Garantía sin vueltas
          </h3>
          <p className="text-xl md:text-2xl text-gray-700 mb-5 leading-relaxed" data-id="element-200">
            Estamos tan seguros de que este Programa te va a encantar, que si no
            es así, te devolvemos el{' '}
            <span className="font-bold text-blue-600" data-id="element-201">100% de tu dinero</span>.
          </p>
          <p className="text-xl md:text-2xl text-gray-700 font-semibold mb-8 leading-relaxed" data-id="element-202">
            Tenés <span className="text-indigo-600 font-bold" data-id="element-203">7 días</span> para
            probarlo sin riesgo. Si no te convence, nos escribís y te hacemos el
            reembolso. Así de simple.
          </p>
          <div className="flex flex-wrap justify-center items-center gap-6 text-base" data-id="element-204">
            <div className="flex items-center gap-3 bg-white px-8 py-4 rounded-full shadow-xl" data-id="element-205">
              <CreditCard className="w-7 h-7 text-indigo-600" data-id="element-206" />
              <span className="font-bold text-gray-800 text-lg" data-id="element-207">
                Compra Segura
              </span>
            </div>
            <div className="flex items-center gap-3 bg-white px-8 py-4 rounded-full shadow-xl" data-id="element-208">
              <ShieldCheck className="w-7 h-7 text-blue-600" data-id="element-209" />
              <span className="font-bold text-gray-800 text-lg" data-id="element-210">
                Material Digital
              </span>
            </div>
            <div className="flex items-center gap-3 bg-white px-8 py-4 rounded-full shadow-xl" data-id="element-211">
              <TrendingUp className="w-7 h-7 text-purple-600" data-id="element-212" />
              <span className="font-bold text-gray-800 text-lg" data-id="element-213">
                Acceso Inmediato
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}